const baseURL = 'https://tienda2.juguetekids.com.pe/';

export default baseURL;
